import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import matchSorter from "match-sorter";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";

import HeaderWrapper from "../../common/HeaderWrapper";
import SupportTicketList from "../../support-ticket/SupportTicketList";
import Modal from "../../common/Modal";
import Loader from "../../common/Loader";

import SupportTicketForm from "../../support-ticket/SupportTicketForm";
import SupportTicketDisplay from "../../support-ticket/SupportTicketDisplay";

const CustomerTicketsPage = ({
  isMobile,
  actions,
  match,
  supportTickets,
  supportTicket,
  codes,
  auth,
  users,
  projects,
  contracts,
  customers
}) => {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [fetched, setFetched] = useState(false);
  const [defaultPageSize, setDefaultPageSize] = useState(
    localStorage.getItem("DEFAULT_PAGE_SIZE_SUPPORT_TICKET_LIST")
      ? parseInt(localStorage.getItem("DEFAULT_PAGE_SIZE_SUPPORT_TICKET_LIST"))
      : 10
  );

  const fetchTickets = useCallback(() => {
    if (actions?.loadTicketsByCustomerId) {
      setLoading(true);
      actions.loadTicketsByCustomerId(match.params.id);
    }
  }, [actions, match]);

  const clearTickets = useCallback(() => {
    if (actions?.clearSupportTicketReducer) {
      setLoading(true);
      actions.clearSupportTicketReducer();
    }
  }, [actions]);

  useEffect(() => {
    if (!supportTickets?.length && !fetched) {
      fetchTickets();
      setFetched(true);
    } else if (supportTickets?.length && !fetched) {
      clearTickets();
    }
  }, [fetchTickets, supportTickets, fetched, clearTickets]);

  useEffect(() => {
    if (supportTickets?.length && fetched) {
      setData(supportTickets);
    }
    if (supportTickets && fetched) {
      setLoading(false);
    }
  }, [fetched, supportTickets]);

  const onFilter = (e) => {
    setSearch(e.target.value);
  };

  const handleClickReassign = (ticket) => {
    actions.getSupportTicket(ticket.id);
    actions.showModal("customerTicketDetailsModal");
  };

  const handleClickView = (ticket) => {
    actions.getSupportTicket(ticket.id);
    actions.showModal("customerSupportTicketDetailsModal");
  };

  const onSaveTicket = async (ticket) => {
    ticket.id = ticket.support_ticket_id;
    delete ticket.support_ticket_id;
    await actions.updateSupportTicket(
      { ...ticket, modified_by_user_id: auth.user._id },
      false,
      "customerTicketDetailsModal"
    );
    actions.clearSupportTicket();
    actions.loadTicketsByCustomerId(match.params.id);
  };

  const onPageSizeChange = (pageSize) => {
    localStorage.setItem("DEFAULT_PAGE_SIZE_SUPPORT_TICKET_LIST", pageSize);
    setDefaultPageSize(pageSize);
  };

  const handleCloseModal = () => {
    actions.hideModal();
    actions.clearSupportTicket();
  };

  const ticketForm = !isEmpty(supportTicket) ? (
    <SupportTicketForm
      supportTicket={supportTicket}
      customers={customers}
      contracts={contracts}
      projects={projects}
      call={supportTicket}
      users={users}
      auth={auth}
      codes={codes}
      saving={false}
      onSave={onSaveTicket}
      onCancel={handleCloseModal}
      editing
      adding
      customerDisabled
    />
  ) : (
    <div>
      <Loader loading />
    </div>
  );

  const supportTicketForm = (
    <SupportTicketDisplay supportTicket={supportTicket} open />
  );

  return (
    <div id="tickets">
      <HeaderWrapper
        breadcrumbs={[{ label: "Tickets" }]}
        onFilter={onFilter}
        isMobile={isMobile}
      />
      <div className="content-wrapper">
        <SupportTicketList
          minimal
          redirectOnTicketNumber
          data={
            search
              ? matchSorter(data, search, {
                  keys: ["request_nature", "support_ticket_number"]
                })
              : data
          }
          defaultButtonText="Reassign"
          isMobile={isMobile}
          loading={loading}
          onClickReassign={handleClickReassign}
          onClickView={handleClickView}
          onPageSizeChange={onPageSizeChange}
          defaultPageSize={defaultPageSize}
          auth={auth}
        />
      </div>
      <Modal
        id="customerTicketDetailsModal"
        title="Edit Ticket"
        body={ticketForm}
        close={handleCloseModal}
      />
      <Modal
        id="customerSupportTicketDetailsModal"
        title="Support Ticket"
        body={supportTicketForm}
        close={handleCloseModal}
      />
    </div>
  );
};

CustomerTicketsPage.propTypes = {
  isMobile: PropTypes.bool,
  actions: PropTypes.object.isRequired,
  match: PropTypes.object,
  supportTickets: PropTypes.array,
  auth: PropTypes.object,
  codes: PropTypes.array,
  users: PropTypes.array,
  contracts: PropTypes.array,
  projects: PropTypes.array,
  customers: PropTypes.array,
  supportTicket: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    supportTicket: state.reducers.supportTicket
  };
}

export default connect(mapStatesToProps, null)(CustomerTicketsPage);
